import { render, staticRenderFns } from "./ClosedAccount.vue?vue&type=template&id=5eb1ef20&scoped=true&"
import script from "./ClosedAccount.vue?vue&type=script&lang=js&"
export * from "./ClosedAccount.vue?vue&type=script&lang=js&"
import style0 from "./ClosedAccount.vue?vue&type=style&index=0&id=5eb1ef20&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb1ef20",
  null
  
)

export default component.exports